var state = {
  id: null,
  options: [] // This stores an array of the selected options
}

$(document).ready(function () {
  const listeners = []
  const selects = [].slice.call(
    $("[data-option-select]")
  );

  // wrapper of the active radios
  const radios = [].slice.call(
    $("[data-option-radio]")
  );

  // active select with variant id as options
  let main = $("[data-option-main]")[0];

  // active product json
  let product = JSON.parse($('[data-product-json]').html());

  // active product variants
  let activeProductVariants = JSON.parse($('[data-product-variant-json]').html());
  
  // variant object where keys are the variants title and values are its ids
  let variants = [].slice.call(main.children).reduce((variants, child) => {
    variants[child.innerHTML.trim()] = child.value;
    return variants;
  }, {});

  // color input: one per product in color collection
  const $colorRadio = $('.js-color-select');

  // containers of the radios in the form (sizes) one per product in collection
  const $formRadios = $('.js-option-radio');

  // select with variant id as options, one per product in collection
  const $mainSelects = $('.js-main-select');

  // product json, one per product in collection
  const $productJsons = $('.js-product-json');

  // product variants json, one per product in collection
  const $productVariantsJsons = $('.js-product-variants-json');

  // groups options per product
  const $allInputSet = $('.js-input-set');

  // images per product
  const $prodImages = $('.js-product-image');

  // price product
  const $productPrice = $('.js-product-price');

  // add to cart button
  const $addToCart = $('.js-add-to-cart');

  // title product
  const $productTitle = $('.js-product-title');

  // title description
  const $productDescription = $('.js-product-description');

  // qtty input
  const $qttyInput = $('.js-qty__num');

  //Color select 
  $colorRadio.on('change', function () {
    // value of the active color
    const val = $(this).val();
    // active color in variable
    const color = $(this).attr('data-color');
    // active color wrapper
    const $optionSet = $('[data-input-set-color="' + color + '"]');
    // active color input
    const $colorOption = $optionSet.find('[data-option="color"] input');
    // active color main select
    const $activeSelect = $('.js-main-select[data-select-color="' + color + '"]');
    // active product json element
    const $activeJson = $('[data-json-color="' + color + '"]');
    // active product variant json element
    const $activeVariantJson = $('[data-variant-json-color="' + color + '"]');
    // active images
    const $activeImages = $('[data-image-color="' + color + '"]');
    // active color wrapper class name
    const inputActive = 'product__input--active';
    // active product json
    product = JSON.parse($activeJson.html());
    // active product variants json
    activeProductVariants = JSON.parse($activeVariantJson.html());
    const price = formatMoney(product.price_min).toString().replace('.00', '');

    //Remove active state for product and variant JSON
    $productJsons.removeAttr('data-product-json');
    $productVariantsJsons.removeAttr('data-product-variant-json');

    //Remove active state on all input groups & inputs
    $allInputSet.removeClass(inputActive);
    $optionSet.addClass(inputActive);
    $formRadios.removeAttr('data-option-radio');

    //Remove active state from main variant select 
    $mainSelects.removeAttr('name');
    $mainSelects.removeAttr('data-option-main');

    //Set active inputs
    $activeSelect.attr('name', 'id');
    $activeSelect.attr('data-option-main', '');
    $optionSet.find('.js-option-radio').attr('data-option-radio', '');

    if ($colorOption.length)
      $colorOption.prop('checked', true).trigger('change');
    
    //Update title    
    $productTitle.hide().html(product.title).fadeIn('slow');

    //Update description
    $productDescription.hide().html(product.description).fadeIn('slow');

    //Update price    
    $productPrice.hide().html(price).fadeIn('slow');

    //Set active product and variant json
    $activeJson.attr('data-product-json', '');
    $activeVariantJson.attr('data-product-variant-json', '');

    //Swap/filter product images
    $prodImages.removeClass('js-product-image-active');

    if ($activeImages.length) {
      $activeImages.each(function () {
        $(this).addClass('js-product-image-active');
      });
    }

    //Set new URL 
    const url = window.location.href.split('products/')[0];
    const nextURL = url + 'products/' + product.handle;
    const nextTitle = product.title + " - tannens'";
    const nextState = { additionalInformation: nextTitle };
    window.history.replaceState(nextState, nextTitle, nextURL);

    //Get new variants array
    main = $("[data-option-main]")[0];
    variants = [].slice.call(main.children).reduce((variants, child) => {
      variants[child.innerHTML.trim()] = child.value;
      return variants;
    }, {});

    const $activeSizes = $optionSet.find('[data-option-radio] input[name="Size"]:not(:disabled)');

    if($activeSizes.length) {
      // trigger change, there are multiple sizes
      $($activeSizes[0]).prop('checked', true).trigger('change');
    } else {
      // there are no sizes
      updateSelection();
    }
  });

  if (!main || !main.length) throw 'data-option-main is missing'
  if (radios.length > 3) throw 'you have more than three radio groups'
  if (selects.length > 3) throw 'you have more than three select inputs'
  
  // fallback if no selects or radios
  state.options[0] = Object.keys(variants);
  
  selects.forEach(select => {
    if (select.nodeName !== 'SELECT') throw 'data-option-select should be defined on the individual option selectors'

    const index = parseInt(select.getAttribute('data-index'))

    // set initial value
    state.options[index] = select.value

    select.addEventListener('change', e => {
      state.options[index] = e.target.value
      updateSelection();
    });
  });

  $(document).on('change', '[data-option-radio] input[type="radio"]', function () {
    const val = $(this).val();
    const index = parseInt($(this).closest('[data-option-radio]').attr('data-index'));
    state.options[index] = val;
    updateSelection();
  });

  // Collect values on page load 
  $formRadios.each(function () {
    const $radioInput = $(this).find('input:checked');
    const val = $radioInput.val();
    const index = parseInt($(this).attr('data-index'));

    if ($radioInput.length > 0) {
      state.options[index] = val;
    }
  });

  updateSelection();

  // Join options into string that matches up with the main select box value
  function updateSelection() {
    const optionString = state.options.join(' / ').replace('&', '&amp;');
    const variantsLength = Object.keys(variants).length;
    if(variantsLength == 1 && optionString.toLowerCase().includes('default')) {
      state.id = Object.values(variants)[0];
    } else {
      state.id = variants[optionString];
    }
    const variant = product.variants.filter(v => v.id === parseInt(state.id))[0];
    
    updateAddToCartState(variant);
    updatePrices(variant);
    updateQttyInput();

    $('[data-option-main]').val(state.id);
    for (let fn of listeners) fn(state);
  }

  function updatePrices(variant) {
    if (variant) {
      const price = variant.price;
      const comparePrice = variant.compare_at_price;
      const priceMoney = formatMoney(price).toString().replace('.00', '');

      $productPrice.html(priceMoney);
      if (comparePrice > price) {
        const comparePriceMoney = formatMoney(comparePrice).toString().replace('.00', '');
        $productPrice.addClass('sale');
      }
      else {
        $productPrice.remove('sale');
      }
    }
  }

  function updateQttyInput() {
    $qttyInput.val(1);
  }

  function updateAddToCartState(variant) {
    let activeProductTitle = product.title.toLowerCase();
    if (!variant || activeProductTitle.includes("gift card"))
      return
    
    let murphysSkus = [];
    let $activeProduct = $('[data-product-json]');
    let productMurphySku = $activeProduct.data('json-murphys-sku');
    let productMurphyLSku = $activeProduct.data('json-murphysl-sku');
    let product_id = $activeProduct.data('product-id');
    let productSection = document.getElementById(`ProductSection-${product.id}`);
    let $addToCart = $('.payment-buttons .add-to-cart');
    let $addToCartText = $('.payment-buttons .add-to-cart span');
    let $buyButton = $('.payment-buttons .shopify-payment-button');
    let $stockMessage = $('.stock-message');
    let $paymentButtons = $('.payment-buttons');
    let shopifyProductInventory = activeProductVariants[variant.id];
    const is_digital = !shopifyProductInventory.management && !shopifyProductInventory.shipping;

    if (productMurphyLSku) {
      murphysSkus.push(productMurphyLSku);
    }

    if (productMurphySku) {
      murphysSkus.push(productMurphySku);
    }

    if (is_digital) {
      adjustInStockMessage();
      adjustAddToCart(1);
    } else {
      getMurphysInventory();
    }

    function adjustAddToCart(inventory) {
      if(inventory < 1) {
        $addToCart.prop('disabled', 'disabled');
        $addToCartText.text('Sold Out');
        $buyButton.hide();
      }
      else {
        $addToCart.prop('disabled', false);
        $addToCartText.text('Add to cart');
        $buyButton.show();
      }
      
      $paymentButtons.removeClass('loading');
    }
    
    function adjustInStockMessage(apiInventory) {
      if (is_digital) {
        let msg = $stockMessage.attr('data-digital');
        if (msg != '') {
          $stockMessage.text(msg);
        }
      }
      else if (shopifyProductInventory.quantity >= 1) {
        let msg = $stockMessage.attr('data-in-store');
        if (msg != '') {
          $stockMessage.text(msg);
        }
      }
      else if ((apiInventory >= 1 && shopifyProductInventory.quantity < 1)) {
        let msg = $stockMessage.attr('data-online-only');
        if (msg != '') {
          $stockMessage.text(msg);
        }
      }
      else if (apiInventory < 1 && shopifyProductInventory.quantity < 1) {
        let msg = $stockMessage.attr('data-no-inventory');
        if (msg != '') {
          $stockMessage.text(msg);
        }
      }
    }
    
    function getMurphysInventory() {
      var totalInventory = 0;
      var apiInventory = 0;
      
      $.ajax({
        url: `${shop.config.api_url}/api/v1/murphys/inventory?id=${product_id}`,
        success: function(result) {
          if (typeof result.inventory_quantity !== 'undefined') {
            //If murphys inventory, add to Shopify inventory
            apiInventory = parseInt(result.inventory_quantity);
            productSection?.setAttribute("data-api-inventory", apiInventory);
            totalInventory = shopifyProductInventory.quantity + apiInventory;
            
            adjustInStockMessage(apiInventory);
            adjustAddToCart(totalInventory);
          } else {
            adjustAddToCart(shopifyProductInventory.quantity);
          }
        },
        error: function(data) {
          //If murphys inventory, add to Shopify inventory
          apiInventory = 0;
          productSection?.setAttribute("data-api-inventory", 0);
          totalInventory = shopifyProductInventory.quantity + apiInventory;
          
          //Change in stock message
          adjustInStockMessage(apiInventory);
          
          //Change cart button
          adjustAddToCart(totalInventory);
        }
      });
    }
  }
});

function formatMoney(cents, format = '${{amount}}') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }

  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2
    thousands = thousands || ','
    decimal = decimal || '.'

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
    const centsAmount = parts[1] ? (decimal + parts[1]) : ''

    return dollarsAmount + centsAmount
  }

  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.')
      break
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ')
      break
  }

  return format.replace(placeholderRegex, value)
}